// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Site header ──
   One primary action (Book a Party), one tonal secondary (Buy Tickets), quiet
   utility controls (Admin, Account with avatar, Cart), and a centered row of
   text links with a pill underline on the active page. Brand violet is used
   solid; a static brand hairline sits on the very top edge as the one playful
   touch. */

.Header_wrapper__ZXAST {
  position: sticky;
  top: 0;
  z-index: 500;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: saturate(160%) blur(10px);
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 0 0 rgba(15, 23, 42, 0);
  transition: box-shadow 200ms ease-out;
}

.Header_wrapper__ZXAST::before {
  content: '';
  display: block;
  height: 3px;
  background: var(--gradient-rainbow);
}

.Header_elevated__tzMJK {
  box-shadow: 0 10px 30px -22px rgba(15, 23, 42, 0.35);
}

.Header_inner__3aTMO {
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 0 24px;
}

/* ── Row 1: brand + actions ── */
.Header_primaryRow__OoSgc {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  min-height: 76px;
  padding: 10px 0;
}

.Header_brand__8KNTg {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
  text-decoration: none;
  flex-shrink: 0;
  border-radius: 8px;
}

.Header_brandSticker__Np0ur {
  height: 44px;
  width: auto;
  object-fit: contain;
  display: block;
}

.Header_brandTagline__bcTzH {
  font-family: 'Fredoka', sans-serif;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #7c3aed;
  padding-left: 2px;
}

.Header_actions__UN-FB {
  display: flex;
  align-items: center;
  gap: 16px;
}

.Header_ctaGroup__zw01- {
  display: flex;
  align-items: center;
  gap: 8px;
}

.Header_utilityGroup__fmGzq {
  display: flex;
  align-items: center;
  gap: 4px;
  padding-left: 16px;
  border-left: 1px solid #e5e7eb;
}

/* ── Buttons ── */
.Header_btn__v0QD3 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 42px;
  padding: 0 18px;
  border-radius: 10px;
  border: 1px solid transparent;
  font-family: 'Fredoka', 'Nunito', sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 0.01em;
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 150ms ease-out, color 150ms ease-out,
    border-color 150ms ease-out, box-shadow 150ms ease-out, transform 150ms ease-out;
}

.Header_btn__v0QD3:active {
  transform: scale(0.98);
  transition-duration: 120ms;
}

.Header_btn__v0QD3:focus-visible,
.Header_navLink__U81jZ:focus-visible,
.Header_menuButton__XsBiY:focus-visible,
.Header_brand__8KNTg:focus-visible {
  outline: 2px solid rgba(124, 58, 237, 0.45);
  outline-offset: 2px;
}

.Header_btnIcon__dEE8a {
  flex-shrink: 0;
  opacity: 0.95;
}

/* Primary: Book a Party */
.Header_btnPrimary__OkdI7 {
  background: #7c3aed;
  color: #ffffff;
  border-color: #7c3aed;
  box-shadow: 0 1px 2px rgba(124, 58, 237, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.14);
}

.Header_btnPrimary__OkdI7:hover {
  background: #6d28d9;
  border-color: #6d28d9;
  box-shadow: 0 4px 12px -4px rgba(124, 58, 237, 0.55);
  transform: translateY(-1px);
}

.Header_btnPrimary__OkdI7:active {
  transform: scale(0.98);
  box-shadow: 0 1px 2px rgba(124, 58, 237, 0.25);
}

/* Tonal secondary: Buy Tickets */
.Header_btnTonal__GuEhH {
  background: #f3effd;
  color: #5b21b6;
  border-color: #f3effd;
}

.Header_btnTonal__GuEhH:hover {
  background: #ebe4fb;
  border-color: #ebe4fb;
  transform: translateY(-1px);
}

/* Quiet: Admin, Account */
.Header_btnQuiet__AIsB4 {
  background: transparent;
  color: #374151;
  padding: 0 12px;
}

.Header_btnQuiet__AIsB4:hover {
  background: #f3f4f6;
  color: #111827;
}

.Header_accountBtn__Zm429 {
  padding-left: 8px;
}

.Header_avatar__OCaEq {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #ede9fe;
  color: #5b21b6;
  font-family: 'Fredoka', sans-serif;
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
}

.Header_accountLabel__wvq-G {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── Row 2: navigation (always visible) ── */
.Header_nav__1ZTJA {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  border-top: 1px solid #f1f5f9;
  padding: 4px 0;
}

.Header_navLink__U81jZ {
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 42px;
  padding: 0 14px;
  font-family: 'Fredoka', 'Nunito', sans-serif;
  font-size: 15px;
  font-weight: 500;
  color: #4b5563;
  border-radius: 8px;
  text-decoration: none;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background-color 150ms ease-out, color 150ms ease-out;
}

.Header_navLink__U81jZ::after {
  content: '';
  position: absolute;
  left: 14px;
  right: 14px;
  bottom: 4px;
  height: 3px;
  border-radius: 3px;
  background: #7c3aed;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 180ms ease-out;
}

.Header_navLink__U81jZ:hover {
  background: #f5f3ff;
  color: #4c1d95;
}

.Header_activeLink__c1Y5h,
.Header_activeLink__c1Y5h:hover {
  color: #6d28d9;
  font-weight: 600;
  background: transparent;
}

.Header_activeLink__c1Y5h::after {
  transform: scaleX(1);
}

/* ── Mobile drawer ── */
.Header_mobileDrawer__wPFjO {
  display: none;
}

.Header_drawerDivider__lF6ec {
  height: 1px;
  background: #e5e7eb;
  margin: 4px 0;
}

.Header_menuButton__XsBiY {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  width: 42px;
  height: 42px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 0;
  cursor: pointer;
  transition: background-color 150ms ease-out, border-color 150ms ease-out;
}

.Header_menuButton__XsBiY:hover {
  background: #f3f4f6;
  border-color: #d1d5db;
}

.Header_menuButton__XsBiY span {
  display: block;
  width: 18px;
  height: 2px;
  background: #374151;
  border-radius: 2px;
  transition: transform 180ms ease-out, opacity 150ms ease-out;
}

.Header_menuButtonOpen__T2\\+32 span:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}

.Header_menuButtonOpen__T2\\+32 span:nth-child(2) {
  opacity: 0;
}

.Header_menuButtonOpen__T2\\+32 span:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

.Header_drawerBtn__LE3oF {
  width: 100%;
  justify-content: center;
}

/* ── Tablet & mobile ── */
@media (max-width: 1080px) {
  .Header_btn__v0QD3 {
    padding: 0 14px;
    font-size: 14px;
  }

  .Header_navLink__U81jZ {
    padding: 0 11px;
    font-size: 14px;
  }

  .Header_navLink__U81jZ::after {
    left: 11px;
    right: 11px;
  }

  .Header_accountLabel__wvq-G {
    display: none;
  }

  .Header_accountBtn__Zm429 {
    padding: 0 8px;
  }
}

@media (max-width: 900px) {
  .Header_inner__3aTMO {
    padding: 0 16px;
  }

  .Header_primaryRow__OoSgc {
    min-height: 64px;
    gap: 12px;
    padding: 8px 0;
  }

  .Header_ctaGroup__zw01-,
  .Header_utilityGroup__fmGzq .Header_btn__v0QD3 {
    display: none;
  }

  .Header_utilityGroup__fmGzq {
    padding-left: 0;
    border-left: none;
  }

  .Header_actions__UN-FB {
    gap: 8px;
  }

  .Header_nav__1ZTJA {
    justify-content: flex-start;
    gap: 0;
    padding: 2px 0;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }

  .Header_nav__1ZTJA::-webkit-scrollbar {
    display: none;
  }

  .Header_menuButton__XsBiY {
    display: flex;
  }

  .Header_mobileDrawer__wPFjO {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    padding: 0;
    transition: max-height 220ms ease-out, opacity 150ms ease-out, padding 220ms ease-out;
  }

  .Header_drawerOpen__uGPqH {
    max-height: 320px;
    opacity: 1;
    padding: 12px 0 16px;
    border-top: 1px solid #e5e7eb;
  }

  .Header_drawerBtn__LE3oF.Header_btnQuiet__AIsB4 {
    justify-content: flex-start;
    padding: 0 12px;
  }
}

@media (max-width: 600px) {
  .Header_brandSticker__Np0ur {
    height: 38px;
  }
}

@media (max-width: 480px) {
  .Header_inner__3aTMO {
    padding: 0 12px;
  }

  .Header_brandSticker__Np0ur {
    height: 34px;
  }

  .Header_brandTagline__bcTzH {
    font-size: 9px;
  }

  .Header_navLink__U81jZ {
    padding: 0 10px;
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/Header.module.css"],"names":[],"mappings":"AAAA;;;;;WAKW;;AAEX;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,qCAAqC;EAErC,0CAA0C;EAC1C,gCAAgC;EAChC,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,4CAA4C;EAC5C,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf;oFACkF;AACpF;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;;;;EAIE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,uFAAuF;AACzF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oDAAoD;EACpD,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,4CAA4C;EAC5C,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,iEAAiE;AACnE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,wEAAwE;AAC1E;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,4DAA4D;AAC9D;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA,0BAA0B;AAC1B;EACE;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,cAAc;EAChB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,2BAA2B;IAC3B,MAAM;IACN,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,UAAU;IACV,qFAAqF;EACvF;;EAEA;IACE,iBAAiB;IACjB,UAAU;IACV,oBAAoB;IACpB,6BAA6B;EAC/B;;EAEA;IACE,2BAA2B;IAC3B,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF","sourcesContent":["/* ── Site header ──\n   One primary action (Book a Party), one tonal secondary (Buy Tickets), quiet\n   utility controls (Admin, Account with avatar, Cart), and a centered row of\n   text links with a pill underline on the active page. Brand violet is used\n   solid; a static brand hairline sits on the very top edge as the one playful\n   touch. */\n\n.wrapper {\n  position: sticky;\n  top: 0;\n  z-index: 500;\n  background: rgba(255, 255, 255, 0.96);\n  -webkit-backdrop-filter: saturate(160%) blur(10px);\n  backdrop-filter: saturate(160%) blur(10px);\n  border-bottom: 1px solid #e5e7eb;\n  box-shadow: 0 0 0 rgba(15, 23, 42, 0);\n  transition: box-shadow 200ms ease-out;\n}\n\n.wrapper::before {\n  content: '';\n  display: block;\n  height: 3px;\n  background: var(--gradient-rainbow);\n}\n\n.elevated {\n  box-shadow: 0 10px 30px -22px rgba(15, 23, 42, 0.35);\n}\n\n.inner {\n  max-width: var(--max-width);\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n/* ── Row 1: brand + actions ── */\n.primaryRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  min-height: 76px;\n  padding: 10px 0;\n}\n\n.brand {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 3px;\n  text-decoration: none;\n  flex-shrink: 0;\n  border-radius: 8px;\n}\n\n.brandSticker {\n  height: 44px;\n  width: auto;\n  object-fit: contain;\n  display: block;\n}\n\n.brandTagline {\n  font-family: 'Fredoka', sans-serif;\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: #7c3aed;\n  padding-left: 2px;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.ctaGroup {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.utilityGroup {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding-left: 16px;\n  border-left: 1px solid #e5e7eb;\n}\n\n/* ── Buttons ── */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 42px;\n  padding: 0 18px;\n  border-radius: 10px;\n  border: 1px solid transparent;\n  font-family: 'Fredoka', 'Nunito', sans-serif;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 1;\n  letter-spacing: 0.01em;\n  text-decoration: none;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background-color 150ms ease-out, color 150ms ease-out,\n    border-color 150ms ease-out, box-shadow 150ms ease-out, transform 150ms ease-out;\n}\n\n.btn:active {\n  transform: scale(0.98);\n  transition-duration: 120ms;\n}\n\n.btn:focus-visible,\n.navLink:focus-visible,\n.menuButton:focus-visible,\n.brand:focus-visible {\n  outline: 2px solid rgba(124, 58, 237, 0.45);\n  outline-offset: 2px;\n}\n\n.btnIcon {\n  flex-shrink: 0;\n  opacity: 0.95;\n}\n\n/* Primary: Book a Party */\n.btnPrimary {\n  background: #7c3aed;\n  color: #ffffff;\n  border-color: #7c3aed;\n  box-shadow: 0 1px 2px rgba(124, 58, 237, 0.25), inset 0 1px 0 rgba(255, 255, 255, 0.14);\n}\n\n.btnPrimary:hover {\n  background: #6d28d9;\n  border-color: #6d28d9;\n  box-shadow: 0 4px 12px -4px rgba(124, 58, 237, 0.55);\n  transform: translateY(-1px);\n}\n\n.btnPrimary:active {\n  transform: scale(0.98);\n  box-shadow: 0 1px 2px rgba(124, 58, 237, 0.25);\n}\n\n/* Tonal secondary: Buy Tickets */\n.btnTonal {\n  background: #f3effd;\n  color: #5b21b6;\n  border-color: #f3effd;\n}\n\n.btnTonal:hover {\n  background: #ebe4fb;\n  border-color: #ebe4fb;\n  transform: translateY(-1px);\n}\n\n/* Quiet: Admin, Account */\n.btnQuiet {\n  background: transparent;\n  color: #374151;\n  padding: 0 12px;\n}\n\n.btnQuiet:hover {\n  background: #f3f4f6;\n  color: #111827;\n}\n\n.accountBtn {\n  padding-left: 8px;\n}\n\n.avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: #ede9fe;\n  color: #5b21b6;\n  font-family: 'Fredoka', sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.accountLabel {\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ── Row 2: navigation (always visible) ── */\n.nav {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  border-top: 1px solid #f1f5f9;\n  padding: 4px 0;\n}\n\n.navLink {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  height: 42px;\n  padding: 0 14px;\n  font-family: 'Fredoka', 'Nunito', sans-serif;\n  font-size: 15px;\n  font-weight: 500;\n  color: #4b5563;\n  border-radius: 8px;\n  text-decoration: none;\n  white-space: nowrap;\n  flex-shrink: 0;\n  transition: background-color 150ms ease-out, color 150ms ease-out;\n}\n\n.navLink::after {\n  content: '';\n  position: absolute;\n  left: 14px;\n  right: 14px;\n  bottom: 4px;\n  height: 3px;\n  border-radius: 3px;\n  background: #7c3aed;\n  transform: scaleX(0);\n  transform-origin: center;\n  transition: transform 180ms ease-out;\n}\n\n.navLink:hover {\n  background: #f5f3ff;\n  color: #4c1d95;\n}\n\n.activeLink,\n.activeLink:hover {\n  color: #6d28d9;\n  font-weight: 600;\n  background: transparent;\n}\n\n.activeLink::after {\n  transform: scaleX(1);\n}\n\n/* ── Mobile drawer ── */\n.mobileDrawer {\n  display: none;\n}\n\n.drawerDivider {\n  height: 1px;\n  background: #e5e7eb;\n  margin: 4px 0;\n}\n\n.menuButton {\n  display: none;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 5px;\n  width: 42px;\n  height: 42px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 0;\n  cursor: pointer;\n  transition: background-color 150ms ease-out, border-color 150ms ease-out;\n}\n\n.menuButton:hover {\n  background: #f3f4f6;\n  border-color: #d1d5db;\n}\n\n.menuButton span {\n  display: block;\n  width: 18px;\n  height: 2px;\n  background: #374151;\n  border-radius: 2px;\n  transition: transform 180ms ease-out, opacity 150ms ease-out;\n}\n\n.menuButtonOpen span:nth-child(1) {\n  transform: translateY(7px) rotate(45deg);\n}\n\n.menuButtonOpen span:nth-child(2) {\n  opacity: 0;\n}\n\n.menuButtonOpen span:nth-child(3) {\n  transform: translateY(-7px) rotate(-45deg);\n}\n\n.drawerBtn {\n  width: 100%;\n  justify-content: center;\n}\n\n/* ── Tablet & mobile ── */\n@media (max-width: 1080px) {\n  .btn {\n    padding: 0 14px;\n    font-size: 14px;\n  }\n\n  .navLink {\n    padding: 0 11px;\n    font-size: 14px;\n  }\n\n  .navLink::after {\n    left: 11px;\n    right: 11px;\n  }\n\n  .accountLabel {\n    display: none;\n  }\n\n  .accountBtn {\n    padding: 0 8px;\n  }\n}\n\n@media (max-width: 900px) {\n  .inner {\n    padding: 0 16px;\n  }\n\n  .primaryRow {\n    min-height: 64px;\n    gap: 12px;\n    padding: 8px 0;\n  }\n\n  .ctaGroup,\n  .utilityGroup .btn {\n    display: none;\n  }\n\n  .utilityGroup {\n    padding-left: 0;\n    border-left: none;\n  }\n\n  .actions {\n    gap: 8px;\n  }\n\n  .nav {\n    justify-content: flex-start;\n    gap: 0;\n    padding: 2px 0;\n    overflow-x: auto;\n    overflow-y: hidden;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n  }\n\n  .nav::-webkit-scrollbar {\n    display: none;\n  }\n\n  .menuButton {\n    display: flex;\n  }\n\n  .mobileDrawer {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    max-height: 0;\n    overflow: hidden;\n    opacity: 0;\n    padding: 0;\n    transition: max-height 220ms ease-out, opacity 150ms ease-out, padding 220ms ease-out;\n  }\n\n  .drawerOpen {\n    max-height: 320px;\n    opacity: 1;\n    padding: 12px 0 16px;\n    border-top: 1px solid #e5e7eb;\n  }\n\n  .drawerBtn.btnQuiet {\n    justify-content: flex-start;\n    padding: 0 12px;\n  }\n}\n\n@media (max-width: 600px) {\n  .brandSticker {\n    height: 38px;\n  }\n}\n\n@media (max-width: 480px) {\n  .inner {\n    padding: 0 12px;\n  }\n\n  .brandSticker {\n    height: 34px;\n  }\n\n  .brandTagline {\n    font-size: 9px;\n  }\n\n  .navLink {\n    padding: 0 10px;\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Header_wrapper__ZXAST`,
	"elevated": `Header_elevated__tzMJK`,
	"inner": `Header_inner__3aTMO`,
	"primaryRow": `Header_primaryRow__OoSgc`,
	"brand": `Header_brand__8KNTg`,
	"brandSticker": `Header_brandSticker__Np0ur`,
	"brandTagline": `Header_brandTagline__bcTzH`,
	"actions": `Header_actions__UN-FB`,
	"ctaGroup": `Header_ctaGroup__zw01-`,
	"utilityGroup": `Header_utilityGroup__fmGzq`,
	"btn": `Header_btn__v0QD3`,
	"navLink": `Header_navLink__U81jZ`,
	"menuButton": `Header_menuButton__XsBiY`,
	"btnIcon": `Header_btnIcon__dEE8a`,
	"btnPrimary": `Header_btnPrimary__OkdI7`,
	"btnTonal": `Header_btnTonal__GuEhH`,
	"btnQuiet": `Header_btnQuiet__AIsB4`,
	"accountBtn": `Header_accountBtn__Zm429`,
	"avatar": `Header_avatar__OCaEq`,
	"accountLabel": `Header_accountLabel__wvq-G`,
	"nav": `Header_nav__1ZTJA`,
	"activeLink": `Header_activeLink__c1Y5h`,
	"mobileDrawer": `Header_mobileDrawer__wPFjO`,
	"drawerDivider": `Header_drawerDivider__lF6ec`,
	"menuButtonOpen": `Header_menuButtonOpen__T2+32`,
	"drawerBtn": `Header_drawerBtn__LE3oF`,
	"drawerOpen": `Header_drawerOpen__uGPqH`
};
export default ___CSS_LOADER_EXPORT___;
